<template>
  <div class="home">
    <header>
      <div class="head-box w1170">
        <div class="head-top">
          <div class="head-left">
            <img src="./../../assets/logo-box-1.png" alt="" />
            <div class="header-pages">
              <Pages active="首页" type="black" />
            </div>
          </div>
          <div class="header-btn">
            <LoginBtn isHome />
          </div>
        </div>
        <div class="head-content">
          <ul class="account">
            <li
              v-for="(item, i) in account"
              :key="item.id"
              class="account-item ver-mid ellipsis"
            >
              <div class="head">
                <img class="ver-mid" :src="item.img" alt="" />
                <div class="ver-mid">
                  <div class="title ellipsis">{{ item.title }}</div>
                  <div class="wx">{{ item.wxnum }}</div>
                  <div class="cm">{{ item.company }}</div>
                </div>
              </div>
              <div class="content box box-pack-between">
                <div class="">
                  <span>粉丝数：</span>
                  <span class="text">{{ item.fansnum }}</span>
                </div>
                <div class="">
                  <span>阅读率：</span>
                  <span class="text">{{ item.read }}</span>
                </div>
              </div>
              <div class="foot box box-pack-between">
                <div class="">
                  <div class="text">{{ item.type }}粉丝群体</div>
                  <div class="text">
                    刊例价：<span
                      >&yen;{{ Math.floor((item.fansnum * 125) / 10000) }}</span
                    >
                  </div>
                </div>
                <div
                  @click="
                    () => {
                      clickButton(i);
                    }
                  "
                  class="button"
                >
                  预约排期
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="head-left-bg"></div>
      </div>
    </header>
    <section>
      <div class="section-box">
        <div class="w1170">
          <div class="section_item1">
            <HomeItem
              title="高效灵活的公众号管理助手"
              padding="48px 0 0 98px"
              url="./function.html?name=account"
              :src="homeItem1"
              :msgs="[
                '多公众号同时登录切换，支持团队化分组管理',
                '智能分析粉丝动向，多维度批量粉丝运营',
              ]"
              isImgFrist
            />
          </div>
        </div>
        <div class="relative">
          <div class="w1170">
            <ul class="section_other">
              <li class="section_other_left"></li>
              <li class="section_other_right"></li>
              <li class="section_other_one">
                <div>
                  <HomeItem
                    title="自由随心的消息推送方式"
                    padding="104px 80px 0 0"
                    url="./function.html?name=news"
                    :src="homeItem2"
                    :msgs="[
                      '打破微信固定推送数量限制',
                      '自主设置推送场景、频率、时段、回复样式',
                    ]"
                  />
                </div>
              </li>
              <li class="section_other_two">
                <div>
                  <HomeItem
                    title="指数级强力涨粉营销工具"
                    padding="16px 0 0 80px"
                    url="./function.html?name=marketing"
                    :src="homeItem3"
                    :msgs="['随机裂变', '裂变活动', '参数二维码']"
                    isImgFrist
                  />
                </div>
              </li>
              <li class="section_other_three">
                <div>
                  <HomeItem
                    title="精准多样的优质流量变现渠道"
                    padding="72px 90px 0 0"
                    :src="homeItem4"
                    :msgs="[
                      '自主选择CPC、CPT、CPS等流量变现方式',
                      '简单开通，数据真实，收益可追溯',
                    ]"
                    url="./flow.html"
                  />
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <PageFooter />
    <Modal class="modal" width="460" v-model="bmodal" @on-ok="buttonOK" :closable="false">
      <div class="head">
        <img class="ver-mid" :src="account[modalIndex].img" alt="" />
        <div class="ver-mid">
          <div class="title">{{ account[modalIndex].title }}</div>
          <div class="">
            <span>粉丝数：</span>
            <span class="text">{{ account[modalIndex].fansnum }}</span>
          </div>
          <div class="">
            <span>阅读率：</span>
            <span class="text">{{ account[modalIndex].read }}</span>
          </div>
        </div>
      </div>
      <div class="content">
        <div class="box m-b-5">
          <span class="label ver-mid">投放日期：</span>
          <DatePicker type="datetime" placeholder="Select date and time" style="width: 200px; margin-left: -9px;" :value="timevalue"></DatePicker>
        </div>
        <div class="box m-b-5 box-pack-around">
          <span class="label ver-mid">投放位置：</span>
          <RadioGroup class="content ver-mid" type="button" value="多图文第一条">
            <Radio class="radio" label="多图文第一条"></Radio>
            <Radio class="radio" label="多图文第二条"></Radio>
            <Radio class="radio" label="多图文第三条"></Radio>
            <Radio class="radio" label="多图文第四条"></Radio>
            <Radio class="radio" label="多图文第五条"></Radio>
            <Radio class="radio" label="多图文第六条"></Radio>
          </RadioGroup>
        </div>
        <div class="box m-b-5 box-pack-around">
          <span class="label ver-mid">留存天数：</span>
          <RadioGroup class="content1 ver-mid" type="button" value="0.5天">
            <Radio class="radio" label="0.5天"></Radio>
            <Radio class="radio" label="1天"></Radio>
            <Radio class="radio" label="3天"></Radio>
            <Radio class="radio" label="7天"></Radio>
          </RadioGroup>
          <span class="tips ver-mid">审核结果确定留存天数</span>
        </div>
        <div>
          <span class="label ver-mid">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;金额：</span>
          <span class="price ver-mid">{{ `&yen;${Math.floor((account[modalIndex].fansnum * 125) / 10000)}
             - &yen;${Math.floor((account[modalIndex].fansnum * 125) / 9000)}` }}</span>
          <span class="tips ver-mid">最终金额以审核后为准</span>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import {
  Modal, RadioGroup, Radio, DatePicker,
} from 'iview';
import Pages from '@/components/Pages';
import LoginBtn from '@/components/LoginBtn';
import HomeItem from '@/components/HomeItem';
import PageFooter from '@/components/PageFooter';
import { jumpLogin } from '@/utils/utils';

import homeItem1 from '@/assets/home-item1.png';
import homeItem2 from '@/assets/home-item2.png';
import homeItem3 from '@/assets/home-item3.png';
import homeItem4 from '@/assets/home-item4.png';
import account1 from '@/assets/1.jpg';
import account2 from '@/assets/2.jpg';
import account3 from '@/assets/3.jpg';
import account4 from '@/assets/4.jpg';
import account5 from '@/assets/5.jpg';
import account6 from '@/assets/6.jpg';
import account7 from '@/assets/7.jpg';
import account8 from '@/assets/8.jpg';

export default {
  name: 'home',
  components: {
    Pages,
    LoginBtn,
    HomeItem,
    PageFooter,
    Modal,
    RadioGroup,
    Radio,
    DatePicker,
  },
  data() {
    return {
      homeItem1,
      homeItem2,
      homeItem3,
      homeItem4,
      jumpLogin,
      timevalue: new Date(),
      bmodal: false,
      modalIndex: 0,
      account1,
      account2,
      account3,
      account4,
      account5,
      account6,
      account7,
      account8,
      account: [
        {
          title: '男人多看书',
          wxnum: 'nrdks001',
          id: 'gh_336fd965cdbf',
          company: '台州松露文化创意有限公司',
          type: '男粉',
          fansnum: 874309,
          read: '1.02%',
          img: account1,
        },
        {
          title: '女子要多读书',
          wxnum: 'miss-dushu',
          id: 'gh_3d72086826a3',
          company: '海盐遥望网络科技有限公司',
          type: '女粉',
          fansnum: 611230,
          read: '1.93%',
          img: account2,
        },
        {
          title: '知书意女子',
          wxnum: 'zhishunvren',
          id: 'gh_bf186e3a6e58',
          company: '杭州柒枫网络科技有限公司',
          type: '女粉',
          fansnum: 606448,
          read: '2.55%',
          img: account3,
        },
        {
          title: '会处事的女子',
          wxnum: 'hcsdnz001',
          id: 'gh_72ddfe1966fa',
          company: '台州松露文化创意有限公司',
          type: '女粉',
          fansnum: 555529,
          read: '2.56%',
          img: account4,
        },
        {
          title: '豪哥说车',
          wxnum: 'haochebang',
          id: 'gh_71f02a48a025',
          company: '杭州尚丽文化创意有限公司',
          type: '男粉',
          fansnum: 539089,
          read: '7.42%',
          img: account5,
        },
        {
          title: '文艺阅书',
          wxnum: 'gh_6e946552',
          id: 'gh_6e946552dedb',
          company: '杭州柒枫网络科技有限公司',
          type: '女粉',
          fansnum: 471347,
          read: '2.38%',
          img: account6,
        },
        {
          title: '叫醒衣橱',
          wxnum: 'bailingyundong',
          id: 'gh_11099594f4a3',
          company: '上饶市付网网络科技有限公司',
          type: '女粉',
          fansnum: 469635,
          read: '1.27%',
          img: account7,
        },
        {
          title: '男子日志录',
          wxnum: 'gh_e48af88d',
          id: 'gh_e48af88de05c',
          company: '西安经济开发区芬层网络工作室',
          type: '男粉',
          fansnum: 468431,
          read: '1.02%',
          img: account8,
        },
      ],
    };
  },
  methods: {
    clickButton(i) {
      this.bmodal = true;
      this.modalIndex = i;
    },
    buttonOK() {
      this.bmodal = false;
      window.open(
        `https://excashier.alipay.com/standard/auth.htm?payOrderId=63df34229b454${Math.random()}`,
      );
    },
  },
};
</script>
<style lang="less">
.modal {

  .head{
    margin-bottom: 20px;
  }
  .title {
    height: 18px;
    font-size: 14px;
    font-weight: bold;
    color: #203152;
    line-height: 18px;
    margin-bottom: 6px;
  }
  img {
    width: 70px;
    height: 70px;
    margin-right: 20px;
    border-radius: 5px;
  }
  .text {
    color: #6772e5;
    font-weight: bold;
  }
  .label{
    width: 78px;
    line-height: 26px;
  }
  .content{
    width: 400px;
  }
  .content1{
    width: 185px;
    margin-left: -13px;
  }
  .radio{
    height: 22px;
    line-height: 22px;
    margin: 5px 3px;
    background: #FFFFFF;
    border-radius: 2px;
    border: 1px solid rgba(0, 0, 0, 0.15);
  }
  .ivu-modal-body{
    padding: 30px;
  }
  .ivu-radio-group-button .ivu-radio-wrapper{
    padding: 0 8px;
  }
  .price{
    color: #ff8541;
    font-size: 18px;
    line-height: 20px;
    font-weight: bold;
  }
  .tips{
    color: #FFA900;
    margin-left: 10px;
    line-height: 28px;
  }
}
.home {
  .account {
    background-color: #f6f9fe;
  }
  .account-item {
    width: 277px;
    height: 200px;
    border-radius: 4px;
    padding: 16px;
    margin: 0 20px 20px 0;
    background-color: #fff;
    .head {
      text-align: top;
      margin-bottom: 14px;
      img {
        width: 70px;
        height: 70px;
        margin-right: 20px;
        border-radius: 5px;
      }
      .title {
        height: 18px;
        font-size: 14px;
        font-weight: bold;
        color: #203152;
        line-height: 18px;
      }
      .wx,
      .cm {
        color: #868e9c;
        font-size: 12px;
        line-height: 18px;
      }
    }
    .content {
      font-size: 14px;
      .text {
        color: #6772e5;
        font-weight: bold;
      }
    }
    .foot {
      margin-top: 20px;
      .text {
        font-size: 12px;
        color: #203152;
        margin-bottom: 12px;
        span {
          color: #ff8541;
          font-size: bold;
        }
      }
      .button {
        font-size: 12px;
        color: #1596ff;
        line-height: 15px;
        letter-spacing: 1px;
        width: 93px;
        height: 30px;
        line-height: 27px;
        border-radius: 20px;
        border: 1px solid #1596ff;
        text-align: center;
        cursor: pointer;
      }
      .button:hover {
        color: #fff;
        background: #1596ff;
        box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1),
          0px 2px 4px 0px rgba(113, 103, 255, 0.2);
      }
    }
  }
  .account-item:nth-child(4),
  .account-item:nth-child(8) {
    margin-right: 0;
  }
  .w1170 {
    width: 1170px;
    margin: 0 auto;
  }
  header {
    height: 585px;
    position: relative;
    overflow: hidden;
    .head-box {
      background: url("./../../assets/bg-head.png") #fff no-repeat center center;
      .head-top {
        overflow: hidden;
        .head-left {
          float: left;
          & > img {
            float: left;
            width: 420px;
            margin-right: 90px;
            margin-bottom: 10px;
          }
          .header-pages {
            float: left;
          }
        }
        .header-btn {
          float: right;
        }
      }
      .head-content {
        overflow: hidden;
        & > ul {
          float: left;
        }
        & > img {
          float: left;
          margin-top: -47px;
        }
        &_strip {
          padding-top: 70px;
        }
        &_title {
          font-size: 48px;
          color: #203152;
          font-weight: bold;
          padding-top: 25px;
        }
        &_msg {
          font-size: 24px;
          color: #203152;
          padding-top: 40px;
        }
        &_btn {
          padding-top: 40px;
        }
      }
      .head-left-bg {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background: #f0f5ff;
        z-index: -1;
      }
    }
  }
  & > section {
    .section-box {
      .section_item1 {
        padding-left: 145px;
        padding-top: 143px;
        padding-bottom: 116px;
      }
      .section_other {
        background: url("./../../assets/bg-home.png") #fff no-repeat center
          158px;
        &_left {
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 50%;
          background: url("./../../assets/bg-home-l.png") repeat-x 0 158px;
          z-index: -1;
        }
        &_right {
          position: absolute;
          top: 0;
          bottom: 0;
          left: 50%;
          right: 0;
          background: url("./../../assets/bg-home-r.png") repeat-x 0 158px;
          z-index: -1;
        }
        &_one {
          overflow: hidden;
          & > div {
            float: right;
            padding-right: 110px;
          }
        }
        &_two {
          padding-top: 100px;
          padding-left: 140px;
        }
        &_three {
          padding-top: 115px;
          padding-bottom: 53px;
          padding-right: 67px;
          overflow: hidden;
          & > div {
            float: right;
          }
        }
      }
    }
  }
}
</style>
